import { useOktaAuth } from '@okta/okta-react';
import { lazy, memo } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Hantz } from '../Hantz';
// import { useAppSelector } from '../common/hooks';
import NotFound from '../pages/404';
import Admin from '../pages/Admin';
// import ClientJourney from '../pages/ClientJourney';
import Clients from '../pages/Clients';
import FinancialAdvisor from '../pages/FinancialAdvisor';
import Resources from '../pages/Resources';
import { RequiredAuth } from './SecureRoute';
import { ADVISOR_ROUTES } from './routeConstants';
import ClientJourney from '../pages/ClientJourney';
import ClientJourneyFlow2 from '../pages/ClientJourneyFlow2';
import { useAppSelector } from '../common/hooks';
import { getClientJourneyFlowType } from '../utils';
import LoginContainer from '../pages/LoginContainer';
const AccessDenied = lazy(() => import('../pages/AccessDenied'));
const RecentUpdates = lazy(() => import('../pages/RecentUpdates'));

const AppRoutes = () => {
    const okta = useOktaAuth();
    const accessToken = okta?.authState?.accessToken?.accessToken;
    const tenant = useAppSelector((state) => state?.auth?.user?.tenant);

    const renderFlowBasedRoutes = () => {
        switch (getClientJourneyFlowType(tenant)) {
            case 'flow1':
                return <Route path={ADVISOR_ROUTES.DASHBOARD} element={<Hantz accessToken={accessToken} />} />;

            case 'flow2':
                return (
                    <>
                        <Route path={ADVISOR_ROUTES.CLIENT_PROFILE} element={<ClientJourneyFlow2 />} />
                        <Route path={ADVISOR_ROUTES.RISK_TOLERANCE} element={<ClientJourneyFlow2 />} />
                        <Route path={ADVISOR_ROUTES.GOALS} element={<ClientJourneyFlow2 />} />
                        <Route path={ADVISOR_ROUTES.FUNDING_NAVIGATOR} element={<ClientJourneyFlow2 />} />
                        <Route path={ADVISOR_ROUTES.PLAN_DETAILS} element={<ClientJourneyFlow2 />} />
                        <Route path={ADVISOR_ROUTES.PLAN_EXECUTION} element={<ClientJourneyFlow2 />} />
                        <Route path={ADVISOR_ROUTES.RESOURCES} element={<Resources />} />
                    </>
                );
            // more flows can be added here
            default:
                return (
                    <>
                        {/* Default Client Journey Routes */}
                        <Route path={ADVISOR_ROUTES.CLIENT_PROFILE} element={<ClientJourney />} />
                        <Route path={ADVISOR_ROUTES.RISK_TOLERANCE} element={<ClientJourney />} />
                        <Route path={ADVISOR_ROUTES.GOALS} element={<ClientJourney />} />
                        <Route path={ADVISOR_ROUTES.PLAN_DETAILS} element={<ClientJourney />} />
                    </>
                );
        }
    };

    return (
        <Routes>
            <Route path={ADVISOR_ROUTES.ROOT} element={<LoginContainer />} />
            <Route path={ADVISOR_ROUTES.LOGIN} element={<LoginContainer />} />
            <Route path={ADVISOR_ROUTES.ACCESS_DENIED} element={<AccessDenied />} />
            <Route element={<RequiredAuth />}>
                <Route path={ADVISOR_ROUTES.ADMIN} element={<Admin />} />
                <Route path={ADVISOR_ROUTES.ADD_USER} element={<FinancialAdvisor />} />
                <Route path={ADVISOR_ROUTES.ADVISOR_CONSOLE} element={<Clients />} />

                {renderFlowBasedRoutes()}

                <Route path={ADVISOR_ROUTES.RECENT_UPDATES} element={<RecentUpdates />} />
                <Route path={ADVISOR_ROUTES.NOT_FOUND} element={<NotFound />} />
            </Route>
        </Routes>
    );
};

export default memo(AppRoutes);